import { StyledProps } from '@emotion/react';
import styled from '@emotion/styled';
import { Space } from '@lib/uikit/theme/types';
import { CSSProperties } from 'react';

export type HStackProps = {
    width?: CSSProperties['width'];
    alignItems?: CSSProperties['alignItems'];
    justifyContent?: CSSProperties['justifyContent'];
    marginBottom?: Space;
    marginTop?: Space;
    paddingInline?: Space;
    spacing?: Space;
    opacity?: CSSProperties['opacity'];
    flexWrap?: CSSProperties['flexWrap'];
    rowSpacing?: Space;
};

export const HStack = styled.div<StyledProps<HStackProps>>`
    display: flex;
    width: ${({ width }) => width};
    align-items: ${({ alignItems }) => alignItems || 'center'};
    gap: ${({ theme, spacing }) => theme.spacing[spacing || 'md']};
    row-gap: ${({ theme, rowSpacing }) => theme.spacing[rowSpacing || 'md']};
    justify-content: ${({ justifyContent }) => justifyContent};
    margin-top: ${({ theme, marginTop }) =>
        marginTop ? theme.spacing[marginTop] : undefined};
    margin-bottom: ${({ theme, marginBottom }) =>
        marginBottom ? theme.spacing[marginBottom] : undefined};
    padding-inline: ${({ theme, paddingInline }) =>
        paddingInline ? theme.spacing[paddingInline] : undefined};
    opacity: ${({ opacity }) => opacity};
    flex-wrap: ${({ flexWrap }) => flexWrap};
`;
